module.exports = "/_next/static/images/ff05ecef2e76f197823bce2a779654f0-circles.svg";